import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'documentType',
  standalone: true,
})
export class DocumentTypePipe implements PipeTransform {
  static prefixes = ['t:', 'i:'];

  transform(value: string | undefined | null): string {
    return DocumentTypePipe.formatValue(value);
  }

  static formatValue(value: string | undefined | null): string {
    if (!value) {
      return '';
    }

    if (value === '362:a' || value === 'c:362:a' || value === 'c:362a') {
      return 'Form 362';
    }
    if (value.startsWith('c:')) {
      const normalized = value.replace(':', '').replace('c', '');
      return (normalized === '362a') ? 'Form 362' : 'Form ' + value.substring(2).replace(':', ' ');
    }
    if (value === 'RC09') {
      return 'Form RC09';
    }
    
    const prefix = DocumentTypePipe.prefixes.find(prefix => value.startsWith(prefix));

    if (prefix) {
      return prefix.substring(0, prefix.length - 1) + ' ' + value.substring(2);
    }

    return value;
  }
}
